import { Button } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";

interface SearchButtonProps {
    onSearch: () => void;
}

const SearchButton: React.FC<SearchButtonProps> = function (props) {
    const { onSearch } = props;

    return (
        <Button
            size="small"
            onClick={() => {
                onSearch();
            }}
            className="mr10"
        >
            搜索
        </Button>
    );
};

export default observer(SearchButton);
